import * as yup from 'yup';
import { CustomerType, DraftAccountDTO } from '../../AccountOpening.meta';

export interface FormValues {
  simpleIraPlanName: string | null;
}

export const parseDefaultValues = (draftAccount: DraftAccountDTO): FormValues => {
  return {
    simpleIraPlanName: draftAccount.simpleIraPlanName,
  };
};

export const parseSubmittedValues = (
  values: FormValues,
  draftAccount: DraftAccountDTO,
): DraftAccountDTO => {
  return {
    ...draftAccount,
    ...values,
    customerType: CustomerType.Ira, // We know the account is of type Retirement -> Save
  };
};

export const validation = yup.object().shape({
  simpleIraPlanName: yup
    .string()
    .nullable()
    .required('Plan name is required'),
});
